'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW_ORDER_SUMMARY = exports.SHOW_ORDER_SUMMARY = 'SHOW_ORDER_SUMMARY';
var HIDE_ORDER_SUMMARY = exports.HIDE_ORDER_SUMMARY = 'HIDE_ORDER_SUMMARY';
var SET_CLICK_AND_COLLECT = exports.SET_CLICK_AND_COLLECT = 'SET_CLICK_AND_COLLECT';
var SHOW_PICKUP_LOCATOR = exports.SHOW_PICKUP_LOCATOR = 'SHOW_PICKUP_LOCATOR';
var HIDE_PICKUP_LOCATOR = exports.HIDE_PICKUP_LOCATOR = 'HIDE_PICKUP_LOCATOR';
var SHOW_CHECKOUT_HELP = exports.SHOW_CHECKOUT_HELP = 'SHOW_CHECKOUT_HELP';
var HIDE_CHECKOUT_HELP = exports.HIDE_CHECKOUT_HELP = 'HIDE_CHECKOUT_HELP';
var SHOW_CHECKOUT_NOTICE = exports.SHOW_CHECKOUT_NOTICE = 'SHOW_CHECKOUT_NOTICE';
var HIDE_CHECKOUT_NOTICE = exports.HIDE_CHECKOUT_NOTICE = 'HIDE_CHECKOUT_NOTICE';

var showOrderSummary = exports.showOrderSummary = function showOrderSummary() {
  return { type: SHOW_ORDER_SUMMARY };
};

var hideOrderSummary = exports.hideOrderSummary = function hideOrderSummary() {
  return { type: HIDE_ORDER_SUMMARY };
};

var showCheckoutHelp = exports.showCheckoutHelp = function showCheckoutHelp() {
  return { type: SHOW_CHECKOUT_HELP };
};

var hideCheckoutHelp = exports.hideCheckoutHelp = function hideCheckoutHelp() {
  return { type: HIDE_CHECKOUT_HELP };
};

var showCheckoutNotice = exports.showCheckoutNotice = function showCheckoutNotice() {
  return { type: SHOW_CHECKOUT_NOTICE };
};

var hideCheckoutNotice = exports.hideCheckoutNotice = function hideCheckoutNotice() {
  return { type: HIDE_CHECKOUT_NOTICE };
};

var setClickAndCollect = exports.setClickAndCollect = function setClickAndCollect(enable) {
  return { type: SET_CLICK_AND_COLLECT, enable: enable };
};

var showPickupLocator = exports.showPickupLocator = function showPickupLocator(term, searchFunc) {
  return { type: SHOW_PICKUP_LOCATOR, term: term, searchFunc: searchFunc };
};

var hidePickupLocator = exports.hidePickupLocator = function hidePickupLocator() {
  return { type: HIDE_PICKUP_LOCATOR };
};

var setAddressBookPage = exports.setAddressBookPage = function setAddressBookPage(page) {
  return { type: 'SET_ADDRESS_BOOK_PAGE', page: page };
};

var setChosenAddress = exports.setChosenAddress = function setChosenAddress(addressType, addressId) {
  return { type: 'SET_CHOSEN_ADDRESS', addressType: addressType, addressId: addressId };
};

var editAddress = exports.editAddress = function editAddress(addressId) {
  return { type: 'EDIT_ADDRESS', addressId: addressId };
};

var hideAddressBook = exports.hideAddressBook = function hideAddressBook() {
  return { type: 'HIDE_ADDRESS_BOOK' };
};

var selectPaymentOption = exports.selectPaymentOption = function selectPaymentOption(paymentOptionId) {
  return { type: 'SELECT_PAYMENT_OPTION', paymentOptionId: paymentOptionId };
};


//////////////////
// WEBPACK FOOTER
// ./shared/actions/presentation.js
// module id = 84
// module chunks = 0